import React from 'react'
import { Layout, Form, Icon, Input, Button, Divider, Row, Col } from 'antd'

import { BrowserRouter as Router, Redirect } from 'react-router-dom'

import authService from '../services/authentication.service'

import {UserContext} from '../contexts/UserContext';

const { Header } = Layout

class NormalLoginForm extends React.Component {
  state = {
    toLandingPage: false,
  }

  handleSubmit = e => {
    e.preventDefault()
    this.props.form.validateFields(async (err, values) => {
      if (!err) {
        const authenticated = await authService.authenticate(
          values.username,
          values.password
        )
        if (authenticated) {

          this.context.setUser(authService.getAuthenticatedUser());

          this.setState({ toLandingPage: true })
        }
      }
    })
  }

  render() {
    if (this.state.toLandingPage === true) {
      const user = authService.getAuthenticatedUser();
      if ( "Administrator" === user.role ) {
          return <Redirect to="/recruitments" />
      }
      else{
          return <Redirect to="/documents" />
      }

    }

    const { getFieldDecorator } = this.props.form
    return (
      <Form onSubmit={this.handleSubmit} className="login-form">
        <Form.Item>
          {getFieldDecorator('username', {
            rules: [{ required: true, message: 'Please input your username!' }],
          })(
            <Input
              prefix={<Icon type="user" style={{ color: '#FFF' }} />}
              placeholder="Username"
            />
          )}
        </Form.Item>
        <Form.Item>
          {getFieldDecorator('password', {
            rules: [{ required: true, message: 'Please input your Password!' }],
          })(
            <Input
              prefix={<Icon type="lock" style={{ color: '#FFF' }} />}
              type="password"
              placeholder="Password"
            />
          )}
        </Form.Item>
        <Form.Item>
          {/*      {getFieldDecorator('remember', {
                        valuePropName: 'checked',
                        initialValue: true,
                    })(<Checkbox>Remember me</Checkbox>)}
                    <a className="login-form-forgot" href="">
                        Forgot password
                    </a>*/}
          <Button
            type="primary"
            size="large"
            shape="round"
            block={true}
            htmlType="submit"
            className="login-form-button"
          >
            Log in
          </Button>
          {/*  Or <a href="">register now!</a>*/}
        </Form.Item>
      </Form>
    )
  }
}

const WrappedNormalLoginForm = Form.create({ name: 'normal_login' })(
  NormalLoginForm
)

const Login = () => {
  return (
    <Layout>
      <section id="login-page">
        <Header className="header">
          <div className="header__logo" />
        </Header>
        <content>
          <section id="login-content">
            <div className="cta">
              <h1>
                Inspire Innovative Approaches for<br></br>Positive Change
              </h1>
              <h3>Survey, Evaluation, Third Party Monitoring</h3>
            </div>
            <Divider type="vertical" />
            <div className="login-form-container">
              <WrappedNormalLoginForm />
            </div>
          </section>
        </content>
      </section>
    </Layout>
  )
}

NormalLoginForm.contextType = UserContext;

export default Login
